// const Url = "http://localhost:5000";
const Url = "https://api-amanah.alhasanah.sch.id";

export default Url;
